import React, {Component} from 'react';
import './NewLabelRequestPage.css';
import Page from '../../components/page/Page';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import Input from '../../inputs/input/Input';
import PrimaryButton from '../../components/primaryButton/PrimaryButton';
import UniversalDropDown from '../../components/universalDropDown/UniversalDropDown';
import mainAPI from '../../api/MainAPI';
import toasts from '../../utils/toasts';

const COLORS = ['blue', 'red', 'green', 'purple', 'yellow', 'orange', 'white', 'black'];
const QUANTITIES = [];
for (let i = 50; i <= 500; i += 50) {
	QUANTITIES.push(i);
}
QUANTITIES.push(750, 1000);

const US_STATES = {
	'AL': 'Alabama', 'AK': 'Alaska', 'AZ': 'Arizona', 'AR': 'Arkansas', 'CA': 'California',
	'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware', 'FL': 'Florida', 'GA': 'Georgia',
	'HI': 'Hawaii', 'ID': 'Idaho', 'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa',
	'KS': 'Kansas', 'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine', 'MD': 'Maryland',
	'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi', 'MO': 'Missouri',
	'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada', 'NH': 'New Hampshire', 'NJ': 'New Jersey',
	'NM': 'New Mexico', 'NY': 'New York', 'NC': 'North Carolina', 'ND': 'North Dakota', 'OH': 'Ohio',
	'OK': 'Oklahoma', 'OR': 'Oregon', 'PA': 'Pennsylvania', 'RI': 'Rhode Island', 'SC': 'South Carolina',
	'SD': 'South Dakota', 'TN': 'Tennessee', 'TX': 'Texas', 'UT': 'Utah', 'VT': 'Vermont',
	'VA': 'Virginia', 'WA': 'Washington', 'WV': 'West Virginia', 'WI': 'Wisconsin', 'WY': 'Wyoming'
};

export default class NewLabelRequestPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email: '',
			name: '',
			organization: '',
			address: '',
			address2: '',
			city: '',
			state: '',
			zip: '',
			phone: '',
			boxSealsCount: 0,
			colorSelections: [{ color: 'blue', quantity: 50 }],
			isSubmitting: false,
			lastSubmitTime: 0
		};
		this.THROTTLE_TIME = 2000;
	}

	componentDidMount = () => {
		this.loadSavedInfo();
	}

	loadSavedInfo = () => {
		const savedInfo = localStorage.getItem('shippingInfo');
		if (savedInfo) {
			try {
				const info = JSON.parse(savedInfo);
				this.setState({
					email: info.email || '',
					name: info.name || '',
					organization: info.organization || '',
					address: info.address || '',
					address2: info.address2 || '',
					city: info.city || '',
					state: info.state || '',
					zip: info.zip || '',
					phone: info.phone || '',
				});
			} catch (e) {
				console.error('Error loading saved info:', e);
			}
		}
	}

	handleFieldChange = (field, value) => {
		this.setState({ [field]: value });
	}

	handleStateChange = (value) => {
		this.setState({ state: value });
	}

	handleBoxSealsChange = (value) => {
		const count = parseInt(value) || 0;
		this.setState({ boxSealsCount: count });
	}


	addColorSelection = () => {
		this.setState(prevState => ({
			colorSelections: [...prevState.colorSelections, { color: 'blue', quantity: 50 }]
		}));
	}

	removeColorSelection = (index) => {
		this.setState(prevState => ({
			colorSelections: prevState.colorSelections.filter((_, i) => i !== index)
		}));
	}

	handleColorChange = (index, color) => {
		this.setState(prevState => {
			const newSelections = [...prevState.colorSelections];
			newSelections[index].color = color;
			return { colorSelections: newSelections };
		});
	}

	handleQuantityChange = (index, quantity) => {
		this.setState(prevState => {
			const newSelections = [...prevState.colorSelections];
			newSelections[index].quantity = parseInt(quantity) || 50;
			return { colorSelections: newSelections };
		});
	}

	validateForm = () => {
		const requiredFields = {
			name: 'Full Name',
			organization: 'Organization',
			address: 'Address',
			city: 'City',
			state: 'State',
			zip: 'ZIP Code'
		};

		for (const [field, label] of Object.entries(requiredFields)) {
			if (!this.state[field] || !this.state[field].trim()) {
				toasts.show(`Please fill in ${label}`);
				return false;
			}
		}

		return true;
	}

	submitForm = async () => {
		const now = Date.now();
		if (this.state.isSubmitting || (now - this.state.lastSubmitTime) < this.THROTTLE_TIME) {
			return;
		}

		if (!this.validateForm()) {
			return;
		}

		this.setState({ isSubmitting: true, lastSubmitTime: now });

		const colorQuantities = this.state.colorSelections.map(selection => ({
			color: selection.color,
			quantity: selection.quantity
		}));

		const formData = {
			email: this.state.email,
			name: this.state.name,
			organization: this.state.organization,
			address: this.state.address,
			address2: this.state.address2,
			city: this.state.city,
			state: this.state.state,
			zip: this.state.zip,
			phone: this.state.phone,
			color_quantities: colorQuantities,
			box_seals_count: this.state.boxSealsCount,
		};

		try {
			const response = await mainAPI.contact_us.labelRequest(formData);
			if (response && response.success) {
				toasts.show('Thank you! Your label request has been submitted.');
				this.setState({
					email: '',
					name: '',
					organization: '',
					address: '',
					address2: '',
					city: '',
					state: '',
					zip: '',
					phone: '',
					boxSealsCount: 0,
					colorSelections: [{ color: 'blue', quantity: 50 }]
				});
			} else {
				toasts.show('There was an error submitting your request. Please try again.');
			}
		} catch (error) {
			console.error('Error:', error);
			toasts.show('There was an error submitting your request. Please try again.');
		} finally {
			this.setState({ isSubmitting: false });
		}
	}

	render() {
		const { colorSelections, isSubmitting } = this.state;
		const stateOptions = {};
		for (const [code, name] of Object.entries(US_STATES)) {
			stateOptions[code] = name;
		}

		const colorOptions = {};
		COLORS.forEach(color => {
			colorOptions[color] = color.charAt(0).toUpperCase() + color.slice(1);
		});

		const quantityOptions = {};
		QUANTITIES.forEach(qty => {
			quantityOptions[qty] = qty.toString();
		});

		return (
			<Page className="g-new-label-request-page">
				<Card>
					<Label larger black>Request Labels & Box Seals</Label>

					<div className="form-section">
						<div className="form-columns">
							<div className="form-column">
								<Label bold black>Email (optional)</Label>
								<Input
									type="email"
									value={this.state.email}
									onChange={(value) => this.handleFieldChange('email', value)}
									placeholder="Enter your email"
								/>

								<Label bold black>Address</Label>
								<Input
									required
									value={this.state.address}
									onChange={(value) => this.handleFieldChange('address', value)}
									placeholder="Street Address"
								/>

								<Label bold black>State</Label>
								<UniversalDropDown
									value={this.state.state}
									options={stateOptions}
									onChange={this.handleStateChange}
									placeholder="Select State"
								/>

								<Label bold black>Unit #</Label>
								<Input
									value={this.state.address2}
									onChange={(value) => this.handleFieldChange('address2', value)}
									placeholder="Apartment, suite, unit, etc."
								/>
							</div>

							<div className="form-column">
								<Label bold black>Full Name</Label>
								<Input
									required
									value={this.state.name}
									onChange={(value) => this.handleFieldChange('name', value)}
									placeholder="Enter your full name"
								/>

								<Label bold black>Organization</Label>
								<Input
									required
									value={this.state.organization}
									onChange={(value) => this.handleFieldChange('organization', value)}
									placeholder="Organization"
								/>

								<Label bold black>City</Label>
								<Input
									required
									value={this.state.city}
									onChange={(value) => this.handleFieldChange('city', value)}
									placeholder="City"
								/>

								<Label bold black>ZIP Code</Label>
								<Input
									required
									type="zip"
									value={this.state.zip}
									onChange={(value) => this.handleFieldChange('zip', value)}
									placeholder="ZIP Code"
								/>

								<Label bold black>Phone Number (optional)</Label>
								<Input
									type="tel"
									value={this.state.phone}
									onChange={(value) => this.handleFieldChange('phone', value)}
									placeholder="Phone Number"
								/>
							</div>
						</div>

						<div className="color-selections-section">
							<Label bold black>Label Colors & Quantities</Label>
							{colorSelections.map((selection, index) => (
								<div key={index} className="color-selection-row">
									<div className="color-selection">
										<Label>Color</Label>
										<UniversalDropDown
											value={selection.color}
											options={colorOptions}
											onChange={(value) => this.handleColorChange(index, value)}
											placeholder="Select Color"
										/>
									</div>
									<div className="quantity-selection">
										<Label>Quantity</Label>
										<UniversalDropDown
											value={selection.quantity}
											options={quantityOptions}
											onChange={(value) => this.handleQuantityChange(index, value)}
											placeholder="Select Quantity"
										/>
									</div>
									{colorSelections.length >= 1 && (
										<button
											type="button"
											className="remove-color-button"
											onClick={() => this.removeColorSelection(index)}
										>
											×
										</button>
									)}
								</div>
							))}
							<PrimaryButton onClick={this.addColorSelection} className="add-color-button">
								Add Another Color
							</PrimaryButton>
						</div>

						<div className="box-seals-section">
							<Label bold black>Box Seals</Label>
							<Input
								type="number"
								min="0"
								value={this.state.boxSealsCount}
								onChange={this.handleBoxSealsChange}
								placeholder="Number of box seals"
							/>
						</div>

						<div className="button-container">
							<PrimaryButton
								onClick={this.submitForm}
								disabled={isSubmitting}
								center
							>
								{isSubmitting ? 'Submitting...' : 'Submit'}
							</PrimaryButton>
						</div>
					</div>
				</Card>
			</Page>
		);
	}
}




// WEBPACK FOOTER //
// ./src/pages/newLabelRequestPage/NewLabelRequestPage.jsx